import type React from 'react';

import classNames from 'classnames';
import { MouseEvent, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { DownloadIcon } from '../../icons/download';
import { Tooltip } from '../tooltip/tooltip';

import styles from './download-sources-menu-button.module.css';

type Props = {
  isActive?: boolean;
  className?: string;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
};

export const DownloadSourcesMenuButtonName = 'download-sources-menu-button';

export function DownloadSourcesMenuButton({ isActive, className, onClick }: Props) {
  const { t } = useTranslation();

  const label = isActive
    ? t('ui.download-source.menu.button.label.active')
    : t('ui.download-source.menu.button.label.inactive');
  const button = useCallback(
    (ref: React.LegacyRef<HTMLButtonElement>, props: Record<string, unknown>) => (
      <button
        data-testid={DownloadSourcesMenuButtonName}
        type="button"
        name={DownloadSourcesMenuButtonName}
        aria-expanded={isActive}
        aria-haspopup="true"
        className={classNames(styles.button, className)}
        onClick={onClick}
        ref={ref}
        {...props}
      >
        <DownloadIcon />
      </button>
    ),
    [className, isActive, onClick]
  );
  return <Tooltip placement="bottom" tooltip={label} trigger={button} />;
}
